module.exports = __webpack_public_path__ + "img/thumbnail_Raccoon_m_erythristic.4a277e86.png";